<template>
    <!-- <div class='big'> -->
        <div id="home_page_map"></div> 
        <!-- <span>单位：张</span>
    </div> -->
</template>
<script>
    import http from '@/api/cardData'
    import Bus from '@/utils/Bus.js'
    import echarts from 'echarts';
    import geoData from '../map-data/get-geography-value.js';
    export default {
        name: 'homeMap',
        data(){
             return{
                 dataItem:[],
                 mapRangeList:[],//地图范围区间数据
                 typeArr:[null,'appointTimeNum','yesterdayNum','monthNum','quarterNum','yearNum','totalNum'],
             }
        },
        props: {
            cityData: Array,
            time:Array,
            dataType:{
                type:String,
                default:'6',
            },
            title:Number,
        },
        watch:{
            'dataType':function(value,oldValue){
                this.initData();
            },
            '$store.state.app.tab':function(value,oldValue){
                this.initData();
            },
        },
        created() {
            this.initData()
        },
        computed: {
            'allTab':function(){
                return this.$store.state.app.tab
            },
            'titleArr':function(){
                return this.$store.state.app.titleArr
            }
        },
        mounted() {
            var convertData = function(data) {
                let res = [];
                let len = data.length;
                for (var i = 0; i < len; i++) {
                    var geoCoord = geoData[data[i].name];
                    if (geoCoord) {
                        res.push({
                            name: data[i].name,
                            value: geoCoord.concat(data[i].value)
                        });
                    }
                }
                return res;
            };
            this.initData();
        },
        methods: {
            initData() {
                let that = this;
                let _options={
                    timeSection:[this.time[0]+'',this.time[1]+''],
                    typeName:this.typeArr[this.dataType]
                };
                http[that.allTab].mapDate(_options).then(e=>{
                    let data = e.data;
                    that.dataItem = data.mapDataList;
                    for( let i = 0;i<data.mapRangeList.length; i++ ){
                        if(data.mapRangeList[i].end ==  -1){
                            data.mapRangeList[i].label = data.mapRangeList[i].start + ' 以上';
                            delete data.mapRangeList[i].end
                        }
                    };
                    that.mapRangeList = [...data.mapRangeList];
                    //对数据进行处理
                    that.initCanvas(this.title);
                })
            },
            initNum(num) {
                num = this.format(num) + '';
                if(num.indexOf('.') == -1){
                    return  num
                }
                return num.split('.')[0]
            },
            format(num) {
                var res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
                    return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
                        return $1+",";
                        });
                })
                return res;
            },
            initCanvas(e) {
                //e为true代表是切换时间
                let that = this;
                let mapData={
                    title: {
                        text: '',
                        subtext: ''
                    },
                    dataRange: {
                        x: 'left',
                        y: '80px',
                        splitList: this.mapRangeList,
                        color: ['#0b65bc', '#3289dc', '#5faef8', '#94cbff'],
                    },
                    tooltip: {
                        // backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        borderWidth: 1,
                        // borderColor: '#ccc',
                        padding: 10,
                        textStyle: {
                            color: '#ffffff'
                        },
                        formatter: function(params) {
                            let data=params.data;
                            //if(!data||(data&&!data.appointTimeNum))return false;
                            if(data&&data.appointTimeNum){
                              return `  <div style='font-size:14px;font-weight:500;'>${data.provinceName}</div>
                                        指定时间新增${that.titleArr[that.allTab]}  <div class="color3">${that.initNum(data.appointTimeNum)}</div>    
                                        昨日新增${that.titleArr[that.allTab]}  <div class="color3">${that.initNum(data.yesterdayNum)}</div> 
                                        本月新增${that.titleArr[that.allTab]}  <div class="color3">${that.initNum(data.monthNum)}</div>
                                        本季度新增${that.titleArr[that.allTab]}  <div class="color3">${that.initNum(data.quarterNum)}</div> 
                                        ${new Date().getFullYear()}年新增${that.titleArr[that.allTab]}  <div class="color3">${that.initNum(data.yearNum)}</div> 
                                        历史累计${that.titleArr[that.allTab]}  <div class="color3">${that.initNum(data.totalNum)}</div>
                                    `;  
                            }else{
                                return '暂无数据';
                            }
                            
                        },
                        extraCssText: 'width: 150px'
                    },
                    toolbox: {
                        show: false,
                        orient: 'vertical',
                        x: 'right',
                        y: 'center',
                        feature: {
                            mark: {
                                show: false
                            },
                            dataView: {
                                show: false,
                                readOnly: false
                            }
                        }
                    },
                    series: [{
                        name: '',
                        type: 'map',
                        mapType: 'china',
                        mapLocation: {
                            x: 'left'
                        },
                        zoom: 1.2,
                        // selectedMode: 'multiple',
                        itemStyle: {
                            normal: {
                                label: {
                                    show: false,
    
                                },
                                areaColor: '#e7e7e7',
                                borderColor: '#ffffff'
                            },
                            emphasis: {
                                areaColor: '#00dcbb',
                                label: {
                                    show: false
                                }
                            }
                        },
                        data:[]
                    }],
                    animation: false
                }
                mapData.series[0].data=this.handleSeriesData(e);
                //mapData.series[0].data=[{name:'北京',value:10}];
                mapData.title.text=this.handleMapTitle(e);
                var map = echarts.init(document.getElementById('home_page_map'));
                const chinaJson = require('../map-data/china.json');
                echarts.registerMap('china', chinaJson);
                map.setOption(mapData);
                window.addEventListener('resize', function() {
                    map.resize();
                });
            },
            // handleMapTitle(e){
            //     let that = this;
            //     let index=e||6;
            //     if(index==1){
            //             return `指定时间新增${that.titleArr[that.allTab]}`
            //     }else if(index==2){
            //             return `昨日新增${that.titleArr[that.allTab]}`
            //     }else if(index==3){
            //             return `本月新增${that.titleArr[that.allTab]}`
            //     }else if(index==4){
            //             return `本季度新增${that.titleArr[that.allTab]}`
            //     }else if(index==5){
            //         return `${new Date().getFullYear()}年新增${that.titleArr[that.allTab]}`
            //     }else{
            //         return `历史累计${that.titleArr[that.allTab]}`
            //     }
            // },
            handleSeriesData(e){
                let index=e||6;
                let arrs=JSON.stringify(this.dataItem);
                let handleArr=JSON.parse(arrs);
                handleArr.forEach(e => {
                    e.name=e.provinceName;
                    if(index==1){
                           e.value=e.appointTimeNum  
                    }else if(index==2){
                          e.value=e.yesterdayNum  
                    }else if(index==3){
                          e.value=e.monthNum 
                    }else if(index==4){
                          e.value=e.quarterNum 
                    }else if(index==5){
                          e.value=e.yearNum 
                    }else{
                          e.value=e.totalNum 
                    }
                });
                return handleArr;
            }
        }
    };
</script>
<style scoped>
#home_page_map{
    width:calc(100% - 10px);
    height:100%;
}
/* .big{
    position: relative;
    height:100%;
}
span{
    position: absolute;
    top:200px;
    height:200px;
    z-index: 10;
} */
</style>

